module.exports = __webpack_public_path__ + "img/cap_08.03a01ded.jpg";